import { z } from 'zod';
import { cepSchema, emailSchema, idSchema, phoneSchema, ufSchema } from './common.js';
import { cnpjSchema } from './documents.js';
/** Empresa (CNPJ) e Unidade (parque, canteiro, filial) — base multiempresa. */
export const companySchema = z.object({
    id: idSchema,
    name: z.string(),
    tradeName: z.string().nullable(),
    document: z.string(),
    stateRegistration: z.string().nullable(),
    email: z.string().nullable(),
    phone: z.string().nullable(),
    zip: z.string().nullable(),
    street: z.string().nullable(),
    number: z.string().nullable(),
    complement: z.string().nullable(),
    district: z.string().nullable(),
    city: z.string().nullable(),
    uf: z.string().nullable(),
    timezone: z.string(),
    /// Última data com o financeiro FECHADO (trava de lançamento/baixa/estorno).
    financialClosedUntil: z.string().nullable(),
    isActive: z.boolean(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
export const companyInputSchema = z.object({
    name: z.string().trim().min(2, 'Informe a razão social').max(180),
    tradeName: z.string().trim().max(180).optional().nullable(),
    document: cnpjSchema,
    stateRegistration: z.string().trim().max(40).optional().nullable(),
    email: emailSchema.optional().nullable(),
    phone: phoneSchema.optional().nullable(),
    zip: cepSchema.optional().nullable(),
    street: z.string().trim().max(180).optional().nullable(),
    number: z.string().trim().max(20).optional().nullable(),
    complement: z.string().trim().max(120).optional().nullable(),
    district: z.string().trim().max(120).optional().nullable(),
    city: z.string().trim().max(120).optional().nullable(),
    uf: ufSchema.optional().nullable(),
});
export const UNIT_KINDS = ['PARQUE', 'CANTEIRO_OBRA', 'ESCRITORIO', 'ALMOXARIFADO'];
export const unitKindSchema = z.enum(UNIT_KINDS);
export const UNIT_KIND_LABELS = {
    PARQUE: 'Parque',
    CANTEIRO_OBRA: 'Canteiro de obra',
    ESCRITORIO: 'Escritório',
    ALMOXARIFADO: 'Almoxarifado',
};
export const unitSchema = z.object({
    id: idSchema,
    companyId: idSchema,
    code: z.string(),
    name: z.string(),
    kind: unitKindSchema,
    city: z.string().nullable(),
    uf: z.string().nullable(),
    isActive: z.boolean(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
export const unitInputSchema = z.object({
    code: z.string().trim().min(1, 'Informe o código').max(20).toUpperCase(),
    name: z.string().trim().min(2, 'Informe o nome').max(120),
    kind: unitKindSchema,
    city: z.string().trim().max(120).optional().nullable(),
    uf: ufSchema.optional().nullable(),
    isActive: z.boolean().default(true),
});
//# sourceMappingURL=org.js.map